module.exports = __webpack_public_path__ + "img/icon-eth-grey.a4ac3058.svg";